import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { businessDetails } from "@/mocks/business";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://tbm-beauty-lab.com";

const DEFAULT_OG_IMAGE =
  "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/og-image.jpeg";

interface SeoMeta {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogImage: string;
  ogType: string;
  twitterCard: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage: string;
}

const SEO_ROUTES: Record<string, SeoMeta> = {
  "/": {
    title: "株式会社TBM健康美容研究所｜高崎市の総合美容・ヘアケア・健康美容",
    description:
      "群馬県高崎市の総合美容、TBM健康美容研究所。ヘアケア商材の開発・流通に加え、教材出版、サロン経営コンサルティング、総合美容検定など健康美容事業を展開。高崎ビューティモード専門学校と連携し美容業界の発展に貢献しています。",
    keywords: "TBM,健康美容研究所,総合美容,高崎,ヘアケア",
    canonical: `${siteUrl}/`,
    ogTitle: "株式会社TBM健康美容研究所｜高崎市の総合美容・ヘアケア・健康美容",
    ogDescription:
      "群馬県高崎市の総合美容、TBM健康美容研究所。ヘアケア商材の開発・流通に加え、教材出版、サロン経営コンサルティング、総合美容検定など健康美容事業を展開。高崎ビューティモード専門学校と連携し美容業界の発展に貢献しています。",
    ogUrl: `${siteUrl}/`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "株式会社TBM健康美容研究所｜高崎市の総合美容・ヘアケア・健康美容",
    twitterDescription:
      "群馬県高崎市の総合美容、TBM健康美容研究所。ヘアケア商材の開発・流通に加え、教材出版、サロン経営コンサルティング、総合美容検定など健康美容事業を展開。高崎ビューティモード専門学校と連携し美容業界の発展に貢献しています。",
    twitterImage: DEFAULT_OG_IMAGE,
  },
  "/links": {
    title:
      "中央カレッジグループ | グループ校・グループ企業一覧 | 株式会社TBM健康美容研究所",
    description:
      "全国に展開する中央カレッジグループのグループ校10校、グループ企業9社、関連機関の一覧。美容・理容・医療・福祉・情報・農業分野の専門学校と企業情報を掲載。",
    keywords:
      "中央カレッジグループ,専門学校,美容,理容,医療,福祉,情報,農業,グループ校,グループ企業",
    canonical: `${siteUrl}/links`,
    ogTitle:
      "中央カレッジグループ | グループ校・グループ企業一覧 | 株式会社TBM健康美容研究所",
    ogDescription:
      "全国に展開する中央カレッジグループのグループ校10校、グループ企業9社、関連機関の一覧。美容・理容・医療・福祉・情報・農業分野の専門学校と企業情報を掲載。",
    ogUrl: `${siteUrl}/links`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle:
      "中央カレッジグループ | グループ校・グループ企業一覧 | 株式会社TBM健康美容研究所",
    twitterDescription:
      "全国に展開する中央カレッジグループのグループ校10校、グループ企業9社、関連機関の一覧。美容・理容・医療・福祉・情報・農業分野の専門学校と企業情報を掲載。",
    twitterImage: DEFAULT_OG_IMAGE,
  },
  "/business": {
    title: "事業内容 | 9つの事業プロジェクト | 株式会社TBM健康美容研究所",
    description:
      "株式会社TBM健康美容研究所が展開する9つの事業プロジェクト一覧。教材・出版、新製品化、健康事業、サロン経営、サロン経営コンサルティング、学校・スクールコンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトをご紹介します。",
    keywords:
      "事業内容,教材出版,新製品化,健康事業,サロン経営,コンサルティング,総合美容検定,スクールセミナー",
    canonical: `${siteUrl}/business`,
    ogTitle: "事業内容 | 9つの事業プロジェクト | 株式会社TBM健康美容研究所",
    ogDescription:
      "株式会社TBM健康美容研究所が展開する9つの事業プロジェクト一覧。教材・出版、新製品化、健康事業、サロン経営、コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトをご紹介します。",
    ogUrl: `${siteUrl}/business`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "事業内容 | 9つの事業プロジェクト | 株式会社TBM健康美容研究所",
    twitterDescription:
      "株式会社TBM健康美容研究所が展開する9つの事業プロジェクト一覧。教材・出版、新製品化、健康事業、サロン経営、コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトをご紹介します。",
    twitterImage: DEFAULT_OG_IMAGE,
  },
  "/privacy": {
    title: "プライバシーポリシー | 株式会社TBM健康美容研究所",
    description:
      "株式会社TBM健康美容研究所のプライバシーポリシー。個人情報の取得・利用目的、第三者提供、安全管理措置、開示・訂正・削除の手続き、お問い合わせ窓口についてご案内しています。",
    keywords: "プライバシーポリシー,個人情報保護,個人情報,プライバシー,TBM健康美容研究所",
    canonical: `${siteUrl}/privacy`,
    ogTitle: "プライバシーポリシー | 株式会社TBM健康美容研究所",
    ogDescription:
      "株式会社TBM健康美容研究所のプライバシーポリシー。個人情報の取得・利用目的、第三者提供、安全管理措置、開示・訂正・削除の手続き、お問い合わせ窓口についてご案内しています。",
    ogUrl: `${siteUrl}/privacy`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "プライバシーポリシー | 株式会社TBM健康美容研究所",
    twitterDescription:
      "株式会社TBM健康美容研究所のプライバシーポリシー。個人情報の取得・利用目的、第三者提供、安全管理措置、開示・訂正・削除の手続き、お問い合わせ窓口についてご案内しています。",
    twitterImage: DEFAULT_OG_IMAGE,
  },
  "/cookie": {
    title: "クッキーポリシー | 株式会社TBM健康美容研究所",
    description:
      "株式会社TBM健康美容研究所のクッキーポリシー。当サイトで利用するクッキーの種類・目的・無効化方法についてご案内しています。",
    keywords: "クッキーポリシー,Cookie,クッキー,TBM健康美容研究所",
    canonical: `${siteUrl}/cookie`,
    ogTitle: "クッキーポリシー | 株式会社TBM健康美容研究所",
    ogDescription:
      "株式会社TBM健康美容研究所のクッキーポリシー。当サイトで利用するクッキーの種類・目的・無効化方法についてご案内しています。",
    ogUrl: `${siteUrl}/cookie`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "クッキーポリシー | 株式会社TBM健康美容研究所",
    twitterDescription:
      "株式会社TBM健康美容研究所のクッキーポリシー。当サイトで利用するクッキーの種類・目的・無効化方法についてご案内しています。",
    twitterImage: DEFAULT_OG_IMAGE,
  },
};

function buildBusinessDetailMeta(
  slug: string,
): SeoMeta | undefined {
  const project = businessDetails.find((item) => item.slug === slug);
  if (!project) {
    return undefined;
  }
  const path = `/business/${project.slug}`;
  const title = `${project.title} | 株式会社TBM健康美容研究所`;
  const description = project.description;
  const keywords = `事業内容,${project.title.replace("プロジェクト", "")},TBM健康美容研究所,高崎,美容`;
  return {
    title,
    description,
    keywords,
    canonical: `${siteUrl}${path}`,
    ogTitle: title,
    ogDescription: description,
    ogUrl: `${siteUrl}${path}`,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: DEFAULT_OG_IMAGE,
  };
}

function ensureMeta(attr: "name" | "property", key: string): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function ensureCanonical(): HTMLLinkElement {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  return el;
}

function removeCanonical(): void {
  const el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (el) {
    el.remove();
  }
}

function removeMeta(attr: "name" | "property", key: string): void {
  const el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (el) {
    el.remove();
  }
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    let meta = SEO_ROUTES[location.pathname];

    // 事業詳細ページはスラッグから動的にメタを生成
    if (!meta && location.pathname.startsWith("/business/")) {
      const slug = location.pathname.replace("/business/", "");
      meta = buildBusinessDetailMeta(slug);
    }

    // 存在しないルート（404）は noindex を付与し、検索エンジンに
    // 薄いページや home メタを流用した重複コンテンツをインデックスさせない
    if (!meta) {
      document.title = "ページが見つかりません | 株式会社TBM健康美容研究所";
      ensureMeta("name", "description").setAttribute(
        "content",
        "お探しのページは見つかりませんでした。株式会社TBM健康美容研究所のトップページから、健康・美容事業や教材出版、サロン経営コンサルティング、総合美容検定などの情報をお探しください。",
      );
      ensureMeta("name", "robots").setAttribute("content", "noindex, nofollow");
      removeCanonical();
      removeMeta("name", "keywords");
      removeMeta("property", "og:title");
      removeMeta("property", "og:description");
      removeMeta("property", "og:url");
      removeMeta("property", "og:image");
      removeMeta("property", "og:type");
      removeMeta("name", "twitter:card");
      removeMeta("name", "twitter:title");
      removeMeta("name", "twitter:description");
      removeMeta("name", "twitter:image");
      return;
    }

    // 既知ルートは index, follow を維持
    ensureMeta("name", "robots").setAttribute("content", "index, follow");

    document.title = meta.title;

    ensureMeta("name", "description").setAttribute("content", meta.description);
    ensureMeta("name", "keywords").setAttribute("content", meta.keywords);
    ensureCanonical().setAttribute("href", meta.canonical);

    ensureMeta("property", "og:title").setAttribute("content", meta.ogTitle);
    ensureMeta("property", "og:description").setAttribute(
      "content",
      meta.ogDescription,
    );
    ensureMeta("property", "og:url").setAttribute("content", meta.ogUrl);
    ensureMeta("property", "og:image").setAttribute("content", meta.ogImage);
    ensureMeta("property", "og:type").setAttribute("content", meta.ogType);

    ensureMeta("name", "twitter:card").setAttribute(
      "content",
      meta.twitterCard,
    );
    ensureMeta("name", "twitter:title").setAttribute(
      "content",
      meta.twitterTitle,
    );
    ensureMeta("name", "twitter:description").setAttribute(
      "content",
      meta.twitterDescription,
    );
    ensureMeta("name", "twitter:image").setAttribute(
      "content",
      meta.twitterImage,
    );
  }, [location.pathname]);

  return null;
}